/** Apple and Google both publish official "Add to Wallet" badges per language.
 * These are the same assets the confirmation emails send, so the email builder
 * preview and the delivered email cannot drift apart. */
const BADGE_BASE = "https://data.diobox.com/app/web/assets/email-dio"

const BADGE_PATHS = {
  apple: `${BADGE_BASE}/add-to-apple-wallet`,
  google: `${BADGE_BASE}/add-to-google-wallet`,
} as const

export type WalletBadgePlatform = keyof typeof BADGE_PATHS

/** Mirrors Event::LANGUAGES; every one has both badges on the CDN. */
export const WALLET_BADGE_LANGUAGES = ["en", "fr", "de", "es", "pt", "nl", "it", "tr"] as const

export const WALLET_BADGE_LANGUAGE_OPTIONS = [
  { label: "English", value: "en" },
  { label: "French", value: "fr" },
  { label: "German", value: "de" },
  { label: "Spanish", value: "es" },
  { label: "Portuguese", value: "pt" },
  { label: "Dutch", value: "nl" },
  { label: "Italian", value: "it" },
  { label: "Turkish", value: "tr" },
]

const badgeLanguage = (language?: string) => (
  WALLET_BADGE_LANGUAGES.includes(language as typeof WALLET_BADGE_LANGUAGES[number])
    ? language
    : "en"
)

export const walletBadgeSrcSet = (platform: WalletBadgePlatform, language?: string) => {
  const base = `${BADGE_PATHS[platform]}/${badgeLanguage(language)}`

  return { src: `${base}.png`, srcSet: `${base}.png 1x, ${base}@2x.png 2x` }
}
